import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Button from '../button';
import GitHubLogo from '../github-logo';
import {Link} from 'react-router-dom'

import './header.css';


const Header = ({authenticated, signOut}) => (
  <header className="header">
    <div className="navbar navbar--extended">
		<nav className="nav__mobile"></nav>
		<div className="container">
			<div className="navbar__inner">
				<Link to="/" className="navbar__logo" style={{fontWeight:'600', color:'#fff'}}>
					<img src="/images/1f428.png" className=""style={{'width':44}} />
				 	 </Link>
				<nav className="">
				{/* <a href="/resources">
					<button  className="button"style={{marginTop:'20px',backgroundColor:'#34d1e2', color:'#fff' ,marginRight:'10px'}}>👥 Makers</button>
					</a> */}
				<Link to="/join">
					<button className="button button__accent" style={{marginTop:'20px'}}>Join the list</button>
					{/* <button className="button" style={{marginTop:'20px'}}>Apply now</button> */}
					</Link>
					
				</nav>
			</div>
		</div>
	</div>
  </header>
);

Header.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  signOut: PropTypes.func.isRequired
};


export default Header;



// WEBPACK FOOTER //
// ./src/views/components/header/header.js